import { DataWriter, SerializationUtil } from ".";

import { CompiledGeometryContainer } from "../Geometry";

export class CompiledGeometryWriter extends DataWriter<CompiledGeometryContainer> {
    public write(geo: CompiledGeometryContainer): Uint8Array {

        let buffer = new ArrayBuffer(1024 + geo.geometry.vertexLength * geo.geometry.vertexCount * 8); // kind of arbitrary size, hope that is enough (and not too much)

        let util = new SerializationUtil().writeTo(new DataView(buffer));

        util.writeString(geo.reference);
        util.writeString(geo.textureReference);

        util.writeUint32(geo.geometry.vertexCount);
        util.writeUint32(geo.geometry.vertexLength);

        util.writeUint8(geo.geometry.dataLayout.length);
        for(let layout of geo.geometry.dataLayout) {
            util
                .writeString(layout.identifier)
                .writeUint8(layout.length)
                .writeUint8(layout.offset);
        }

        util.writeVaryingFloat32Array(geo.geometry.geometryData);

        return util.finalize(true);
    }

}